import { MainCard, MainCardTitle } from "src/components/main-card-type.tsx";

import { ContadorDiasResult } from "../Contador-dias";
import { ContadorTable } from "./ContadorTable";

export const ContadorResponse = ({
  results,
}: {
  results: ContadorDiasResult;
}) => {
  return (
    <MainCard className="mt-4">
      <MainCardTitle>Resultado</MainCardTitle>

      {/* Centraliza e mantém largura */}
      <div className="flex justify-center mb-2">
        <div className="w-full sm:w-1/2 lg:w-1/3 p-3 bg-primary rounded border flex flex-col justify-center">
          <h2 className="sm:text-base text-sm text-center text-white font-semibold m-0">
            Dias úteis
          </h2>
          <p className="sm:text-xl text-center font-bold text-md text-white m-0">
            {results.diasUteis}
          </p>
        </div>
      </div>
      <ContadorTable results={results} />
    </MainCard>
  );
};
